import { CircularProgress } from "@kaggle/material";
import styled from "styled-components";
import * as React from "react";
import { CircularHover } from "./CircularHover";

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

// HACK: Normally I would add styles here but that does not work inside the editor iframe.
// Styled-component styling currently does not work there due to shadow DOM cascade issues.
// Future browser versions have a property that will enable better cascade options.
// Inline styling works for this use case in the meantime.
const Body = styled.div``;

const StopIcon = styled.div``;

export const CircularProgressButton = React.memo((props: Props) => (
  <Body
    className="cell-execution-button"
    onClick={props.onClick}
    style={{
      position: "relative",
      alignItems: "center",
      justifyContent: "center",
      height: "24px",
      width: "24px",
      boxSizing: "border-box",
      cursor: "pointer",
    }}
  >
    <CircularProgress
      className="circular-progress-background"
      progress={1}
      style={{
        position: "absolute",
        left: "8.33%",
        right: "8.33%",
        top: "8.33%",
        bottom: "8.33%",
        boxSizing: "border-box",
        width: 20,
        height: 20,
        fontSize: "1rem",
      }}
    />
    <CircularProgress
      style={{
        position: "absolute",
        left: "8.33%",
        right: "8.33%",
        top: "8.33%",
        bottom: "8.33%",
        boxSizing: "border-box",
        width: 20,
        height: 20,
        fontSize: "1rem",
      }}
    />
    <StopIcon
      className="circular-progress-stop-icon"
      style={{
        backgroundColor: "#fff",
        fontSize: "6px",
        width: "6px",
        height: "6px",
        position: "absolute",
        left: "37.5%",
        right: "37.5%",
        top: "37.5%",
        bottom: "37.5%",
        boxSizing: "border-box",
      }}
    />
    {!props.disabled && <CircularHover />}
  </Body>
));
